import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectDetails: {
		id: 'business-summary.summary-view.project-details.project-details',
		defaultMessage: 'Project details',
		description: 'Label for the button that toggles visibility of project details.',
	},
});
